import { createRouter, createWebHistory } from 'vue-router';
import MainBody from './components/MainBody.vue';
import MovieDetails from './components/MovieDetails.vue';

const routes = [
  { path: '/', component: MainBody },
  { path: '/movie/:id', component: MovieDetails, props: true }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
